/**
 * brand.js — assets y helpers de marca LEADCEM (self-hosted en public/brand/).
 *
 * Reglas de tema (mismo-origen, sin depender de CDN externo, sin filtros CSS):
 *   - tema CLARO  → logo/isotipo COLOR   (leadcem-logo.png / leadcem-isotipo.png)
 *   - tema OSCURO → logo/isotipo BLANCO  (…-white.png)  ← alto contraste sobre fondo oscuro
 *
 * En fondos SIEMPRE oscuros (panel izq de login, activar/reset, ApiDocs) usar
 * BRAND.logoWhite fijo. NO usar para el logo white-label por empresa (company.logo_url).
 *
 * Los `-negative.png` (negro monocromo) son para fondo claro; hoy sin uso (claro usa color).
 */
// Nombre de marca — fuente ÚNICA. Cambiar aquí (1 línea) para rebrandear todo el frontend.
export const APP_NAME = 'LEADCEM';

export const BRAND = {
  logo: '/brand/leadcem-logo.png', // horizontal, color (fondo claro)
  logoWhite: '/brand/leadcem-logo-white.png', // horizontal, blanco (fondo oscuro)
  logoNegative: '/brand/leadcem-logo-negative.png', // horizontal, negro monocromo (sin uso hoy)
  isotipo: '/brand/leadcem-isotipo.png',
  isotipoWhite: '/brand/leadcem-isotipo-white.png', // isotipo blanco (fondo oscuro)
  isotipoNegative: '/brand/leadcem-isotipo-negative.png', // isotipo negro monocromo (sin uso hoy)
};

export const logoForTheme = (theme) => (theme === 'light' ? BRAND.logo : BRAND.logoWhite);
export const isotipoForTheme = (theme) => (theme === 'light' ? BRAND.isotipo : BRAND.isotipoWhite);
